const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { MomentOffered } from './MomentOffered';
import * as utils_topshot from "./utils_topshot"
import * as utils_time from "./utils_time"
import * as utils from "./utils"

export const DEALOFFER_REDIS_LIST_PREFIX = 'ts1'

export class DealOffer extends MomentOffered {
  public offerID: number = null
  public dealRating: number = null
  public gone: boolean = null
  public numClicks?: number = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)
  constructor(po?: object) {
    super(po)
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
  }

  public isSafe(): boolean {
    if (!super.isSafe()) return false
    return true
  }

  // e.g. https://livetoken.co/goto/p2p/ddfe1fcb-c3f5-449f-b645-5fc4d308cc64+a22a0228-73fb-445e-9ee5-a35e4aadc9fe?type=2&value=100
  public getViewURL(): string {
    // Jan 22, 2024
    return `https://livetoken.co/goto/p2p/${this.setGUID}_${this.playGUID}?type=2&value=${this.offerPrice}`
  }


  public getDealRatingString(): string {
    if (this.dealRating < 1) return '+'
    return '🏀'.repeat(this.dealRating)
  }
  public getDealRatingHTML(): string {
    if (this.dealRating < 1) return '+'
    const oneFlame: string = '<img class="dealFlame" src="/images/flame_emoji_32x41.png" />'
    return oneFlame.repeat(this.dealRating)
  }

}



(async () => {
})();
